import { useState, useContext, useEffect, Fragment } from 'react';
import { useForm, useWatch } from 'react-hook-form'
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup";
import { CheckIcon, SelectorIcon, SwitchHorizontalIcon, UserIcon } from '@heroicons/react/solid';
import { Listbox, RadioGroup, Transition } from '@headlessui/react'
import { toast } from 'react-toastify'
import { getFunctions, httpsCallable } from "firebase/functions";
import { useIntercom } from 'react-use-intercom';
import { useFirestore } from "react-redux-firebase";

import Button from '@/components/Button';
import Toast from '../../components/Toast';
import { convertAmount } from '../../utils/currencyResolver';
import { ModalContext } from '../../contexts/ModalContext';
import { AuthContext } from '../../contexts/AuthContext';
import { useBalance } from '@/hooks/useBalance'
import errorToast from '@/utils/errorToast'

export default function DepositPanel() {
  const [mode, setMode] = useState("Gold")
  const [method, setMethod] = useState("07")
  const [isLoading, setIsLoading] = useState(false)
  const { closeModal } = useContext(ModalContext)
  const { exchangeRate, fiatRate } = useContext(AuthContext)
  const functions = getFunctions();
  const createOrder = httpsCallable(functions, 'createOrder');
  const { showNewMessages } = useIntercom();



  // const schema = yup.object().shape({
  //   rsn: yup.string().required(),
  //   amount: yup.number().required().positive().min(20),
  //   mode: yup.mixed().oneOf(['GOLD', 'CRYPTO']),
  //   method: yup.mixed().oneOf(['07', 'RS3', 'BTC', 'ETH', 'LTC'])
  // });

  // const { register, handleSubmit, control, getValues, setValue, formState: { errors, isSubmitting }, reset } = useForm({
  //   resolver: yupResolver(schema),
  //   defaultValues: {
  //     mode: "GOLD",
  //     method: "07",
  //     amount: 0
  //   }
  // });

  // const amount = useWatch({
  //   control,
  //   name: "amount",
  //   defaultValue: 0
  // });

  // const { displayValue, value } = useBalance(amount)

  // useEffect(() => {
  //   setValue('method', method)
  // }, [method])

  // useEffect(() => {
  //   setValue('mode', mode)
  //   if (mode == "GOLD") {
  //     setMethod('07')
  //   } else {
  //     setMethod('BTC')
  //   }
  // }, [mode])

  // const onSubmitHandler = async (data) => {
  //   try {
  //     setIsLoading(true)
  //     const order = await createOrder({
  //       ...data,
  //       type: 'Deposit',
  //       method
  //     })
  //     if (method == "RS3") {
  //       showNewMessages(`I would like to deposit ${convertAmount(data.amount)} RS3 for ${convertAmount(data.amount / exchangeRate.value)} 07. Here is my order ${order.data}`)
  //     } else {
  //       showNewMessages(`I would like to deposit ${convertAmount(data.amount)} 07. Here is my order ${order.data}`)
  //     }
  //     closeModal()
  //   } catch (error) { console.log(error.message) }
  //   setIsLoading(false)
  // }


  // const handleChange = e => {
  //   setValue('amount', e.target.value * 1000000)
  // }

  return (
    <div className="mt-8">
      <div className="mb-4">
        <label className="block mb-1 font-medium text-sm">Deposit Type</label>
        <RadioGroup value={mode} onChange={setMode}>

          <div className="grid grid-cols-2 gap-4">
            <RadioGroup.Option
              key={1}
              value="Gold"
              className={({ checked }) =>
                `
                  ${checked ? 'border-purple-600 opacity-100' : 'border-transparent opacity-60'
                }
                  cursor-pointer bg-gray-900 border-2 relative rounded py-2.5 transition duration-300 px-4 flex items-center justify-center font-medium text-white`
              }
            >
              {({ checked }) => (
                <>
                  <div className="flex items-center w-full relative">
                    <RadioGroup.Label
                      as="p"
                      className={`font-medium text-white mx-auto flex justify-center text-center`}
                    >
                      Gold
                    </RadioGroup.Label>
                    {checked && (
                      <div className="flex-shrink-0 text-white absolute right-0">
                        <CheckIcon className="w-5 h-5" />
                      </div>
                    )}
                  </div>
                </>
              )}
            </RadioGroup.Option>
            <RadioGroup.Option
              key={2}
              value="Crypto"
              className={({ checked }) =>
                `
                  ${checked ? 'border-purple-600 opacity-100' : 'border-transparent opacity-60'
                }
                  cursor-pointer bg-gray-900 border-2 relative rounded py-2.5 transition duration-300 px-4 flex items-center justify-center font-medium text-white`
              }
            >
              {({ checked }) => (
                <>
                  <div className="flex items-center w-full relative">
                    <RadioGroup.Label
                      as="p"
                      className={`font-medium text-white mx-auto flex justify-center text-center`}
                    >
                      Crypto
                    </RadioGroup.Label>
                    {checked && (
                      <div className="flex-shrink-0 text-white absolute right-0">
                        <CheckIcon className="w-5 h-5" />
                      </div>
                    )}
                  </div>
                </>
              )}
            </RadioGroup.Option>
          </div>
        </RadioGroup>
      </div>
      {mode == "Gold" && <GoldDeposit onClose={() => closeModal()} />}
      {mode == "Crypto" && <CryptoDeposit onClose={() => closeModal()} />}
      {/* <form onSubmit={handleSubmit(onSubmitHandler)} className="grid gap-4">
        <div>
          <label className="block mb-1 font-medium text-sm">Deposit Type</label>
          <RadioGroup value={mode} onChange={setMode}>

            <div className="grid grid-cols-2 gap-4">
              <RadioGroup.Option
                key={1}
                value="GOLD"
                className={({ checked }) =>
                  `
                  ${checked ? 'border-purple-600 opacity-100' : 'border-transparent opacity-60'
                  }
                  cursor-pointer bg-gray-900 border-2 relative rounded py-2.5 transition duration-300 px-4 flex items-center justify-center font-medium text-white`
                }
              >
                {({ checked }) => (
                  <>
                    <div className="flex items-center w-full relative">
                      <RadioGroup.Label
                        as="p"
                        className={`font-medium text-white mx-auto flex justify-center text-center`}
                      >
                        Gold
                      </RadioGroup.Label>
                      {checked && (
                        <div className="flex-shrink-0 text-white absolute right-0">
                          <CheckIcon className="w-5 h-5" />
                        </div>
                      )}
                    </div>
                  </>
                )}
              </RadioGroup.Option>
              <RadioGroup.Option
                key={2}
                value="CRYPTO"
                className={({ checked }) =>
                  `
                  ${checked ? 'border-purple-600 opacity-100' : 'border-transparent opacity-60'
                  }
                  cursor-pointer bg-gray-900 border-2 relative rounded py-2.5 transition duration-300 px-4 flex items-center justify-center font-medium text-white`
                }
              >
                {({ checked }) => (
                  <>
                    <div className="flex items-center w-full relative">
                      <RadioGroup.Label
                        as="p"
                        className={`font-medium text-white mx-auto flex justify-center text-center`}
                      >
                        Crypto
                      </RadioGroup.Label>
                      {checked && (
                        <div className="flex-shrink-0 text-white absolute right-0">
                          <CheckIcon className="w-5 h-5" />
                        </div>
                      )}
                    </div>
                  </>
                )}
              </RadioGroup.Option>
            </div>
          </RadioGroup>
        </div>
        {mode == "GOLD" ? (
          <div>
            <label className="block mb-1 font-medium text-sm">Game Mode</label>
            <RadioGroup value={method} onChange={setMethod}>

              <div className="grid grid-cols-2 gap-4">
                <RadioGroup.Option
                  key={1}
                  value="07"
                  className={({ checked }) =>
                    `
                  ${checked ? 'border-purple-600 opacity-100' : 'border-transparent opacity-60'
                    }
                  cursor-pointer bg-gray-900 border-2 relative rounded py-2.5 transition duration-300 px-4 flex items-center justify-center font-medium text-white`
                  }
                >
                  {({ checked }) => (
                    <>
                      <div className="flex items-center w-full relative">
                        <RadioGroup.Label
                          as="p"
                          className={`font-medium text-white mx-auto flex justify-center text-center`}
                        >
                          07
                        </RadioGroup.Label>
                        {checked && (
                          <div className="flex-shrink-0 text-white absolute right-0">
                            <CheckIcon className="w-5 h-5" />
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </RadioGroup.Option>
                <RadioGroup.Option
                  key={2}
                  value="RS3"
                  className={({ checked }) =>
                    `
                  ${checked ? 'border-purple-600 opacity-100' : 'border-transparent opacity-60'
                    }
                  cursor-pointer bg-gray-900 border-2 relative rounded py-2.5 transition duration-300 px-4 flex items-center justify-center font-medium text-white`
                  }
                >
                  {({ checked }) => (
                    <>
                      <div className="flex items-center w-full relative">
                        <RadioGroup.Label
                          as="p"
                          className={`font-medium text-white mx-auto flex justify-center text-center`}
                        >
                          RS3
                        </RadioGroup.Label>
                        {checked && (
                          <div className="flex-shrink-0 text-white absolute right-0">
                            <CheckIcon className="w-5 h-5" />
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </RadioGroup.Option>
              </div>
            </RadioGroup>
          </div>
        ) : (
          <div>
            <label className="block mb-1 font-medium text-sm">Select Crypto</label>
            <Listbox value={method} onChange={setMethod}>
              <div className="relative mt-1">
                <Listbox.Button className="selectbox flex relative w-full py-2 pl-3 pr-10 text-left shadow-md">
                  <span className="block truncate">{method}</span>
                  <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                    <SelectorIcon
                      className="w-5 h-5"
                      aria-hidden="true"
                    />
                  </span>
                </Listbox.Button>
                <Transition
                  as={Fragment}
                  leave="transition ease-in duration-100"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Listbox.Options className="absolute w-full py-1 mt-1 overflow-auto bg-gray-900 border-2 border-gray-300 rounded border-opacity-30 z-50 shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                    {CryptoOptions.map((person, personIdx) => (
                      <Listbox.Option
                        key={personIdx}
                        className={({ active }) =>
                          `cursor-default select-none relative py-2 pl-10 pr-4 ${active ? 'bg-gray-800' : 'hover:bg-gray-800'
                          }`
                        }
                        value={person}
                      >
                        {({ selected }) => (
                          <>
                            <span
                              className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                }`}
                            >
                              {person}
                            </span>
                            {selected ? (
                              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                                <CheckIcon className="w-5 h-5" aria-hidden="true" />
                              </span>
                            ) : null}
                          </>
                        )}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </Transition>
              </div>
            </Listbox>
          </div>
        )}
        <div>
          <label className="block mb-1 font-medium text-sm">Runescape Name</label>
          <input {...register('rsn')} type="text" required />
          {errors?.rsn && <p className="bg-red-200 p-2 border border-red-800 text-center text-red-800 rounded-md mt-2 text-xs">{errors.rsn?.message}</p>}
        </div>
        {mode == "GOLD" ? (
          method == "RS3" ? (
            <>
              <div className="flex items-center">
                <div className="flex-1">
                  <label className="block mb-1 font-medium text-sm">RS3 <span className="text-xs">({convertAmount(amount)})</span></label>
                  <div className="relative">
                    <input {...register('amount')} type="hidden" required className={errors?.amount ? '!border-red-500 absolute' : ' absolute'} />
                    <input type="number" step=".01" value={displayValue} onChange={handleChange} required className={errors?.amount ? '!border-red-500' : ''} />
                    <div className="absolute right-0 inset-y-0 flex p-1">
                      <div className="px-3 bg-gray-800 rounded shadow font-medium text-sm flex items-center justify-center">M</div>
                    </div>
                  </div>
                  {errors?.amount && <p className="text-red-500 font-medium rounded-md mt-2 text-xs">{errors.amount?.message}</p>}
                </div>
                <div className="mt-4 mx-2">
                  <SwitchHorizontalIcon className="h-5" />
                </div>
                <div className="flex-1">
                  <label className="block mb-1 font-medium text-sm">07 <span className="text-xs">({convertAmount(value / exchangeRate.value)})</span></label>
                  <div className="relative">
                    <input value={(displayValue / exchangeRate.value).toFixed(2)} className="bg-gray-700 border-gray-800 border-transparent shadow-md" type="number" readOnly />
                    <div className="absolute right-0 inset-y-0 flex p-1">
                      <div className="px-3 bg-gray-800 rounded shadow font-medium text-sm flex items-center justify-center">M</div>
                    </div>
                  </div>
                  {errors?.amount && <p className="text-red-500 font-medium rounded-md mt-2 text-xs">{errors.amount?.message}</p>}
                </div>
              </div>
              <p className="text-gray-300 text-xs">
                All RS3 deposits will be converted to an 07 balance. 1M 07 = {exchangeRate.value}M RS3
              </p>
            </>
          ) : (
            <div>
              <label className="block mb-1 font-medium text-sm">Deposit <span className="text-xs">({convertAmount(amount)})</span></label>
              <div className="relative">
                <input {...register('amount')} type="hidden" required className={errors?.amount ? '!border-red-500 absolute' : ' absolute'} />
                <input type="number" step=".01" value={displayValue} onChange={handleChange} required className={errors?.amount ? '!border-red-500' : ''} />
                <div className="absolute right-0 inset-y-0 flex p-1">
                  <div className="px-3 bg-gray-800 rounded shadow font-medium text-sm flex items-center justify-center">M</div>
                </div>
              </div>
              {errors?.amount && <p className="text-red-500 font-medium rounded-md mt-2 text-xs">{errors.amount?.message}</p>}
            </div>
          )
        ) : (
          <>
            <div className="flex items-center">
              <div className="flex-1">
                <label className="block mb-1 font-medium text-sm">$USD ({method}) <span className="text-xs"></span></label>
                <div className="relative">
                  <input {...register('amount')} type="hidden" required className={errors?.amount ? '!border-red-500 absolute' : ' absolute'} />
                  <input type="number" step=".01" value={displayValue} onChange={handleChange} required className={errors?.amount ? '!border-red-500' : ''} />
                  <div className="absolute right-0 inset-y-0 flex p-1">
                    <div className="px-3 bg-gray-800 rounded shadow font-medium text-sm flex items-center justify-center">M</div>
                  </div>
                </div>
                {errors?.amount && <p className="text-red-500 font-medium rounded-md mt-2 text-xs">{errors.amount?.message}</p>}
              </div>
              <div className="mt-4 mx-2">
                <SwitchHorizontalIcon className="h-5" />
              </div>
              <div className="flex-1">
                <label className="block mb-1 font-medium text-sm">07 <span className="text-xs">({convertAmount(value / fiatRate.value)})</span></label>
                <div className="relative">
                  <input value={(displayValue / fiatRate.value).toFixed(2)} className="bg-gray-700 border-gray-800 border-transparent shadow-md" type="number" readOnly />
                  <div className="absolute right-0 inset-y-0 flex p-1">
                    <div className="px-3 bg-gray-800 rounded shadow font-medium text-sm flex items-center justify-center">M</div>
                  </div>
                </div>
                {errors?.amount && <p className="text-red-500 font-medium rounded-md mt-2 text-xs">{errors.amount?.message}</p>}
              </div>
            </div>
            <p className="text-gray-300 text-xs">
              All Crypto deposits will be converted to an 07 balance. 1M 07 = ${fiatRate.value}
            </p>
          </>
        )}
        <div>
          <Button modifier="secondary" type="submit" className="py-3.5 w-full">
            {isSubmitting ? (
              <span className="flex items-center justify-center">
                Processing
                <svg className="animate-spin ml-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </span>
            ) : (
              <span>Deposit</span>
            )}
          </Button>
        </div>
      </form> */}
    </div>
  )
}

const GoldDeposit = ({ onClose }) => {
  const { exchangeRate, fiatRate } = useContext(AuthContext)
  const functions = getFunctions();
  const createOrder = httpsCallable(functions, 'createOrder');
  const { showNewMessages } = useIntercom();

  const GoldOptions = [
    '07', 'RS3'
  ]

  const schema = yup.object().shape({
    rsn: yup.string().required(),
    method: yup.mixed().oneOf(GoldOptions),
    amount: yup.number().required().positive(),
  });

  const { register, handleSubmit, control, setValue, formState: { errors, isSubmitting }, reset } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      method: GoldOptions[0],
      amount: 0
    }
  });

  const onSubmitHandler = async (data) => {
    try {
      const order = await createOrder({
        ...data,
        type: 'Deposit',
        mode: 'Gold',
        method: method,
        amount: Number(amount * 1000000),
        value: method == "07" ? Number(amount * fiatRate.value) : Number((amount / exchangeRate.value) * fiatRate.value),
      })
      if (method == "RS3") {
        showNewMessages(`I (${data?.rsn}), would like to deposit ${convertAmount(amount * 1000000)} RS3 for ${convertAmount(amount * 1000000 / exchangeRate.value)} 07. Here is my order ${order.data}.`)
      }
      if (method == "07") {
        showNewMessages(`I (${data?.rsn}), would like to deposit ${convertAmount(amount * 1000000)} 07. Here is my order ${order.data}.`)
      }
      onClose()
    } catch (error) {
      errorToast(error)
    }
  }

  const method = useWatch({
    control,
    name: "method",
    defaultValue: GoldOptions[0]
  });
  const amount = useWatch({
    control,
    name: "amount",
    defaultValue: 0,
  });

  // useEffect(() => {
  //   if (value) {
  //     setAmount(((value / fiatRate.value) * 1000000).toFixed(2))
  //   }
  // }, [value])

  return (
    <form onSubmit={handleSubmit(onSubmitHandler)} className="grid gap-4">
      <div>
        <label className="block mb-1 font-medium text-sm">Select Game</label>
        <Listbox value={method} onChange={(val) => setValue('method', val)}>
          <div className="relative mt-1">
            <Listbox.Button className="selectbox flex relative w-full py-2 pl-3 pr-10 text-left shadow-md">
              <span className="block truncate">{method}</span>
              <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                <SelectorIcon
                  className="w-5 h-5"
                  aria-hidden="true"
                />
              </span>
            </Listbox.Button>
            <Transition
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute w-full py-1 mt-1 overflow-auto bg-gray-900 border-2 border-gray-300 rounded border-opacity-30 z-50 shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                {GoldOptions.map((person, personIdx) => (
                  <Listbox.Option
                    key={personIdx}
                    className={({ active }) =>
                      `cursor-default select-none relative py-2 pl-10 pr-4 ${active ? 'bg-gray-800' : 'hover:bg-gray-800'
                      }`
                    }
                    value={person}
                  >
                    {({ selected }) => (
                      <>
                        <span
                          className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                            }`}
                        >
                          {person}
                        </span>
                        {selected ? (
                          <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                            <CheckIcon className="w-5 h-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </Listbox>
      </div>
      <div>
        <label className="block mb-1 font-medium text-sm">Runescape Name</label>
        <input {...register('rsn')} type="text" required />
        {errors?.rsn && <p className="bg-red-200 p-2 border border-red-800 text-center text-red-800 rounded-md mt-2 text-xs">{errors.rsn?.message}</p>}
      </div>
      {method == "RS3" ? (
        <>
          <div className="flex items-center">
            <div className="flex-1">
              <label className="block mb-1 font-medium text-sm">RS3 <span className="text-xs">({convertAmount(amount * 1000000)})</span></label>
              <div className="relative">
                <input {...register('amount')} type="number" step=".01" required className={errors?.amount ? '!border-red-500' : ''} />
                <div className="absolute right-0 inset-y-0 flex p-1">
                  <div className="px-3 bg-gray-800 rounded shadow font-medium text-sm flex items-center justify-center">M</div>
                </div>
              </div>
              {errors?.amount && <p className="text-red-500 font-medium rounded-md mt-2 text-xs">{errors.amount?.message}</p>}
            </div>
            <div className="mt-4 mx-2">
              <SwitchHorizontalIcon className="h-5" />
            </div>
            <div className="flex-1">
              <label className="block mb-1 font-medium text-sm">07 <span className="text-xs">({convertAmount(amount * 1000000 / exchangeRate.value)})</span></label>
              <div className="relative">
                <input value={(amount / exchangeRate.value).toFixed(2)} className="bg-gray-700 border-gray-800 border-transparent shadow-md" type="number" readOnly />
                <div className="absolute right-0 inset-y-0 flex p-1">
                  <div className="px-3 bg-gray-800 rounded shadow font-medium text-sm flex items-center justify-center">M</div>
                </div>
              </div>
              {errors?.amount && <p className="text-red-500 font-medium rounded-md mt-2 text-xs">{errors.amount?.message}</p>}
            </div>
          </div>
          <p className="text-gray-300 text-xs">
            All RS3 deposits will be converted to an 07 balance. 1M 07 = {exchangeRate.value}M RS3
          </p>
        </>
      ) : (
        <div>
          <label className="block mb-1 font-medium text-sm">Deposit <span className="text-xs">({convertAmount(amount * 1000000)})</span></label>
          <div className="relative">
            <input {...register('amount')} type="number" step=".01" required className={errors?.amount ? '!border-red-500 absolute' : ''} />
            <div className="absolute right-0 inset-y-0 flex p-1">
              <div className="px-3 bg-gray-800 rounded shadow font-medium text-sm flex items-center justify-center">M</div>
            </div>
          </div>
          {errors?.amount && <p className="text-red-500 font-medium rounded-md mt-2 text-xs">{errors.amount?.message}</p>}
        </div>
      )}
      {/* 
      <div>
        <div className="flex items-center">
          <div className="flex-1">
            <label className="block mb-1 font-medium text-sm">$USD ({method}) <span className="text-xs"></span></label>
            <div className="relative">
              <input {...register('value')} type="number" step=".01" required className={errors?.amount ? '!border-red-500' : ''} />
              <div className="absolute right-0 inset-y-0 flex p-1">
                <div className="px-3 bg-gray-800 rounded shadow font-medium text-sm flex items-center justify-center">$</div>
              </div>
            </div>
            {errors?.amount && <p className="text-red-500 font-medium rounded-md mt-2 text-xs">{errors.amount?.message}</p>}
          </div>
          <div className="mt-4 mx-2">
            <SwitchHorizontalIcon className="h-5" />
          </div>
          <div className="flex-1">
            <label className="block mb-1 font-medium text-sm">07 <span className="text-xs">({convertAmount((value / fiatRate.value) * 1000000)})</span></label>
            <div className="relative">
              <input className="bg-gray-700 border-gray-800 border-transparent shadow-md" value={(value / fiatRate.value).toFixed(2)} type="number" readOnly />
              <div className="absolute right-0 inset-y-0 flex p-1">
                <div className="px-3 bg-gray-800 rounded shadow font-medium text-sm flex items-center justify-center">M</div>
              </div>
            </div>
            {errors?.amount && <p className="text-red-500 font-medium rounded-md mt-2 text-xs">{errors.amount?.message}</p>}
          </div>
        </div>
        <p className="text-gray-300 text-xs mt-4">
          All Crypto deposits will be converted to an 07 balance. 1M 07 = ${fiatRate.value}
        </p>
      </div> */}
      <div>
        <Button modifier="secondary" type="submit" className="py-3.5 w-full">
          {isSubmitting ? (
            <span className="flex items-center justify-center">
              Processing
              <svg className="animate-spin ml-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </span>
          ) : (
            <span>Deposit</span>
          )}
        </Button>
      </div>
    </form>
  )
}

const CryptoDeposit = ({ onClose }) => {
  const { fiatRate } = useContext(AuthContext)
  const functions = getFunctions();
  const createOrder = httpsCallable(functions, 'createOrder');
  const { showNewMessages } = useIntercom();
  const [amount, setAmount] = useState(0)

  const CryptoOptions = [
    'BTC', 'ETH', 'LTC', 'USDT'
  ]

  const schema = yup.object().shape({
    rsn: yup.string().required(),
    method: yup.mixed().oneOf(CryptoOptions),
    value: yup.number().required().positive()
  });

  const { register, handleSubmit, control, setValue, formState: { errors, isSubmitting }, reset } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      method: CryptoOptions[0],
      value: 0
    }
  });

  const onSubmitHandler = async (data) => {
    try {
      const order = await createOrder({
        ...data,
        type: 'Deposit',
        mode: 'Crypto',
        method: method,
        amount: Number(amount),
        value: Number(value),
      })
      showNewMessages(`I (${data?.rsn}), would like to deposit $${value} worth of ${method} for ${convertAmount(amount)} 07. Here is my order ${order.data}.`)
      onClose()
    } catch (error) {
      errorToast(error)
    }
  }

  const method = useWatch({
    control,
    name: "method",
    defaultValue: CryptoOptions[0]
  });
  const value = useWatch({
    control,
    name: "value",
    defaultValue: 0,
  });

  useEffect(() => {
    if (value) {
      setAmount(((value / fiatRate.value) * 1000000).toFixed(2))
    }
  }, [value])

  return (
    <form onSubmit={handleSubmit(onSubmitHandler)} className="grid gap-4">
      <div>
        <label className="block mb-1 font-medium text-sm">Select Crypto</label>
        <Listbox value={method} onChange={(val) => setValue('method', val)}>
          <div className="relative mt-1">
            <Listbox.Button className="selectbox flex relative w-full py-2 pl-3 pr-10 text-left shadow-md">
              <span className="block truncate">{method}</span>
              <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                <SelectorIcon
                  className="w-5 h-5"
                  aria-hidden="true"
                />
              </span>
            </Listbox.Button>
            <Transition
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute w-full py-1 mt-1 overflow-auto bg-gray-900 border-2 border-gray-300 rounded border-opacity-30 z-50 shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                {CryptoOptions.map((person, personIdx) => (
                  <Listbox.Option
                    key={personIdx}
                    className={({ active }) =>
                      `cursor-default select-none relative py-2 pl-10 pr-4 ${active ? 'bg-gray-800' : 'hover:bg-gray-800'
                      }`
                    }
                    value={person}
                  >
                    {({ selected }) => (
                      <>
                        <span
                          className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                            }`}
                        >
                          {person}
                        </span>
                        {selected ? (
                          <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                            <CheckIcon className="w-5 h-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </Listbox>
      </div>
      <div>
        <label className="block mb-1 font-medium text-sm">Runescape Name</label>
        <input {...register('rsn')} type="text" required />
        {errors?.rsn && <p className="bg-red-200 p-2 border border-red-800 text-center text-red-800 rounded-md mt-2 text-xs">{errors.rsn?.message}</p>}
      </div>
      <div>
        <div className="flex items-center">
          <div className="flex-1">
            <label className="block mb-1 font-medium text-sm">$USD ({method}) <span className="text-xs"></span></label>
            <div className="relative">
              <input {...register('value')} type="number" step=".01" required className={errors?.amount ? '!border-red-500' : ''} />
              <div className="absolute right-0 inset-y-0 flex p-1">
                <div className="px-3 bg-gray-800 rounded shadow font-medium text-sm flex items-center justify-center">$</div>
              </div>
            </div>
            {errors?.amount && <p className="text-red-500 font-medium rounded-md mt-2 text-xs">{errors.amount?.message}</p>}
          </div>
          <div className="mt-4 mx-2">
            <SwitchHorizontalIcon className="h-5" />
          </div>
          <div className="flex-1">
            <label className="block mb-1 font-medium text-sm">07 <span className="text-xs">({convertAmount((value / fiatRate.value) * 1000000)})</span></label>
            <div className="relative">
              <input className="bg-gray-700 border-gray-800 border-transparent shadow-md" value={(value / fiatRate.value).toFixed(2)} type="number" readOnly />
              <div className="absolute right-0 inset-y-0 flex p-1">
                <div className="px-3 bg-gray-800 rounded shadow font-medium text-sm flex items-center justify-center">M</div>
              </div>
            </div>
            {errors?.amount && <p className="text-red-500 font-medium rounded-md mt-2 text-xs">{errors.amount?.message}</p>}
          </div>
        </div>
        <p className="text-gray-300 text-xs mt-4">
          All Crypto deposits will be converted to an 07 balance. 1M 07 = ${fiatRate.value}
        </p>
      </div>
      <div>
        <Button modifier="secondary" type="submit" className="py-3.5 w-full">
          {isSubmitting ? (
            <span className="flex items-center justify-center">
              Processing
              <svg className="animate-spin ml-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </span>
          ) : (
            <span>Deposit</span>
          )}
        </Button>
      </div>
    </form>
  )
}